import { Select } from "antd";
import { useLanguage } from "@/hook/useLanguage";
import { languageOptions } from "@/constants/miscConstants";

const LanguageDropdown = ({ className }) => {
  const { language, setLanguage } = useLanguage();

  return (
    <Select
      value={language}
      onChange={setLanguage}
      options={languageOptions}
      size="middle"
      className={className}
    />
  );
};

export default LanguageDropdown;
